/**
 * See if a property is being ordered from a URL parameter.
 * @param property Property name.
 * @param orderBy  Order by URL parameter value.
 * @returns        True if the property is being ordered.
 *
 * @example
 * // Returns true:
 * isOrderedByProperty("property", "property.asc")
 *
 * // Returns false:
 * isOrderedByProperty("property", "other_property.asc")
 */
export const isOrderedByProperty = (property: string, orderBy?: string) => {
    if (typeof orderBy !== "string") {
        return false;
    }

    return new RegExp(`^${property}\\.(asc|desc)$`, "i").test(orderBy.trim());
};
